<template>
  <div>
    <div class="py-4" v-for="joined in joinedItems" :key="joined.id">
      <div class="row no-gutters">
        <div class="col-12 pa-1">
          <div class="row">
            <h4 class="col">{{ joined.name }}</h4>
            <div class="col-auto">
              <small class="caption">Meta</small> &nbsp; {{ joined.amount_to_pay | price }}
            </div>
          </div>
        </div>
        <div class="col-12 pa-1">
          <v-alert outlined dense color="success lighten-5" class="mb-0">
            <div class="row">
              <div class="col-6 col-sm-3 success--text">
                <small class="caption grey--text">Total Pago</small>
                <br>
                <b>{{ joined.total_paid | price }}</b>
              </div>
              <div class="col-6 col-sm-3 success--text">
                <small class="caption grey--text">Pago por fora</small>
                <br>
                {{ joined.total_paid_before | price }}
              </div>
              <div class="col-6 col-sm-3 success--text">
                <small class="caption grey--text">Pago pela Heppi</small>
                <br>
                {{ joined.total_paid_without_interest_and_fine | price }}
              </div>
              <div class="col-6 col-sm-3 success--text">
                <small class="caption grey--text">Juros pago</small>
                <br>
                {{ joined.total_paid_interest_and_fine | price }}
              </div>
            </div>
          </v-alert>
        </div>
        <div class="col-12 col-sm-3 pa-1">
          <v-alert outlined dense color="error lighten-5" class="mb-0">
            <div class="row">
              <div class="col-12 error--text">
                <small class="caption grey--text">Total atrasado</small>
                <br>
                {{ joined.total_late | price }}
              </div>
            </div>
          </v-alert>
        </div>
        <div class="col-6 col-sm-3 pa-1">
          <v-alert outlined dense color="info lighten-3" class="mb-0">
            <div class="row">
              <div class="col-12 info--text">
                <small class="caption grey--text">Em aberto</small>
                <br>
                {{ joined.total_pending | price }}
              </div>
            </div>
          </v-alert>
        </div>
        <div class="col-12 col-sm-6 pa-1">
          <v-alert outlined dense color="grey lighten-2" class="mb-0">
            <div class="row">
              <div class="col-6 black--text">
                <small class="caption grey--text">Parcelas restantes</small>
                <br>
                {{ joined.number_of_installment }}x ({{ joined.method | payment_method }}<template v-if="joined.period && joined.period !== 'ALL'"> | {{ joined.period }}</template>)
              </div>
              <div class="col-6 black--text">
                <small class="caption grey--text">Renegociação</small>
                <br>
                <template v-if="joined.loading_provisioning_itens">Carregando</template>
                <template v-else>{{ joined.provisioning_renegotiation | price }}</template>
              </div>
            </div>
          </v-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'printFundraisings',
  props: {
    participantId: {
      type: String
    },
    joineds: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      joinedItems: []
    }
  },
  methods: {
    getNegotiationData (index, page) {
      const newJoined = { ...this.joinedItems[index] }

      axios.get(`/financial-negotiations?page[size]=30&page[number]=${page}&filter[joined_id]=${newJoined.joined_id}`)
        .then(response => {
          if (response.data) {
            const data = response.data.data
            const meta = response.data.meta

            if (data) {
              newJoined.negotiations = [...newJoined.negotiations, ...data]
              this.$set(this.joinedItems, index, newJoined)
            }

            if (meta && meta.current_page < meta.last_page) {
              this.getNegotiationData(index, page + 1)
            } else {
              newJoined.loading_provisioning_itens = false
              this.$set(this.joinedItems, index, newJoined)
              this.setProvisioningTotals(index)
            }
          }
        })
        .catch(() => {
          newJoined.loading_provisioning_itens = false
          this.$set(this.joinedItems, index, newJoined)
        })
    },
    setProvisioningTotals (index) {
      const newJoined = { ...this.joinedItems[index] }
      newJoined.provisioning_renegotiation = 0
      newJoined.provisioning_additional = 0
      newJoined.provisioning_discount = 0
      newJoined.provisioning_interest_and_fines = 0
      newJoined.has_previous_provisioning = false
      newJoined.has_more_provisioning = false

      for (const i in newJoined.negotiations) {
        const item = newJoined.negotiations[i]

        if (!item.generated_invoice && item.category === 'renegotiation') {
          newJoined.provisioning_renegotiation += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'additional') {
          newJoined.provisioning_additional += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'discount') {
          newJoined.provisioning_discount += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'interest_and_fines') {
          newJoined.provisioning_interest_and_fines += item.installment_amount
        }

        const itemDate = this.$moment(item.due_date).startOf('month')
        const actualData = this.actualMoment().startOf('month')
        const monthDiff = itemDate.diff(actualData, 'months')
        console.log(monthDiff)

        if (!item.generated_invoice && monthDiff <= 0) {
          newJoined.has_previous_provisioning = true
        }

        if (!item.generated_invoice && monthDiff > newJoined.max_installments) {
          newJoined.has_more_provisioning = true
        }
      }

      this.$set(this.joinedItems, index, newJoined)
    },
    actualMoment () {
      let actualMoment = this.$moment()
      const actualDay = parseInt(actualMoment.format('D'))
      if (actualDay < 5) actualMoment.subtract(1, 'months')
      return actualMoment
    }
  },
  mounted () {
    if (this.joineds && this.joineds.length > 0) this.joinedItems = [...this.joineds]
    else this.joinedItems = []

    if (this.joinedItems.length > 0) {
      for (const i in this.joinedItems) {
        const newJoined = { ...this.joinedItems[i] }
        newJoined.loading_provisioning_itens = true
        newJoined.negotiations = []
        this.$set(this.joinedItems, i, newJoined)
        setTimeout(() => {
          this.getNegotiationData(i, 1)
        }, 1000)
      }
    }
  }
}
</script>
